import _ from "lodash"
import { filterErrors } from 'data/lib/validation'
import validationService from 'data/validate'

// returns a tuple of the commonly needed details
export function getPropertyDetails(property) {
  let calcDetail = null, calcStatus = null, errordetail = null, severe = null
  if(!property) return {calcDetail, calcStatus, errordetail, severe}
  const folderErrors = _.get(validationService.value(), `errordetail.folder.${property.folderid}`)
  const severeFolder = _.some(folderErrors, err => _.includes(err?.tags, `${err?.type}:severe`))

  calcDetail = property.calcdetail
  calcStatus = calcDetail ? calcDetail.status : null
  errordetail = filterErrors(property.errordetail)
  if (severeFolder) {
    errordetail = {...(errordetail||{}), folder: {[property.folderid]: folderErrors}}
  }
  severe = _.chain(errordetail).values().map(_.values).flattenDeep().some(err => _.includes(err?.tags, `${err?.type}:severe`)).value()

  return {calcDetail, calcStatus, errordetail, severe, severeFolder, folderErrors }
}